<template>
    <div class='official-profile-container'>
        <img src="../../../public/static/images/official/profile/1.png" alt="">
        <img src="../../../public/static/images/official/profile/2.png" alt="">
        <img src="../../../public/static/images/official/profile/3.png" alt="">
    </div>
</template>

<script>

export default {
    name: '',
    components: {},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {},
}
</script>
<style lang='less' scoped>
.official-profile-container {
    font-size: 0;

    img {
        width: 100%;
        vertical-align: top;
        margin-top: -2px;
    }
}
</style>